import React from "react";
import "../App.css";
const Footer = () => {
  return (
    <div>
      <footer className="footer">
        <div className="text-footer">
          <span>&copy; Musty - Music Charity</span>
        </div>
      </footer>
    </div>
  );
};
export default Footer;
